import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.object.keys";
import "core-js/modules/web.dom-collections.for-each";
var orderSourceObj = {
  1: '小程序',
  2: 'App',
  3: '公众号',
  4: '收银台',
  5: '自助收银',
  6: '第三方',
  7: '管理后台'
};
var orderTypeObj = {
  100: '收银系统-手动添加',
  106: '收银系统-油机订单',
  201: '特殊结算-自用',
  202: '特殊结算-回灌',
  203: '特殊结算-异常未收款',
  204: '特殊结算-事故核销',
  205: '特殊结算-跑单',
  206: '特殊结算-抽空',
  207: '特殊结算-已收款核销',
  501: '微信小程序',
  701: '兑换',
  801: '线上商城',
  802: '商城兑换'
};
var chargeOrderTypeObj = {
  301: '储值卡充值',
  302: '微信小程序储值卡充值',
  303: '管理后台-大客户充值',
  304: '储值卡大客户授信充值',
  401: '储值卡大客户授信回款',
  601: '电子钱包充值'
};
var payChannelObj = {
  1001: '现金',
  1002: '储值卡',
  1003: '通联-支付宝',
  1004: '通联-微信',
  1005: '通联-POS机',
  1013: '拉卡拉-支付宝',
  1014: '拉卡拉-微信',
  1015: '拉卡拉-POS机',
  1023: '富友-支付宝',
  1024: '富友-微信',
  1025: '富友-POS机',
  1045: '星驿-POS机',
  1006: '公账打款',
  1007: '特殊结算',
  1008: '支付宝刷脸付',
  1009: '其他',
  1010: '电子钱包',
  1011: '积分兑换',
  2001: '滴滴',
  2002: '货车帮',
  2003: '易加油',
  2004: '团油',
  2005: '小象',
  2006: '储值卡(旧)',
  2007: '嗨卡',
  2008: '喂车车',
  2009: '途虎',
  2010: '货拉拉',
  2011: '佰思达',
  2012: '爱车平台',
  2013: '团油车队',
  2014: '鲸车惠',
  3001: '线上商城',
  7000: '后台回款',
  7001: '挂失补办',
  7002: '授权卡',
  7005: '记账卡',
  4444: '旧系统充值'
};
var payTypeObj = {
  1: '普通卡',
  2: '授权卡',
  5: '记账卡'
};
var orderTitleObj = {
  'userId': '用户ID',
  'totalSaleAmount': '订单销售总金额',
  'totalAmount': '订单总金额',
  'totalPay': '订单总实付',
  'totalDiscount': '订单总优惠',
  'sellerDiscountAmount': '商家优惠金额',
  'couponDiscountAmount': '优惠券优惠金额',
  'tradeFee': '手续费',
  'tradeDiscount': '支付优惠',
  'payAt': '支付时间',
  'Timestamp': '下单时间',
  'mainOrderNo': '主订单号',
  'orderSource': '订单来源',
  'orderType': '订单类型',
  'payChannel': '交易方式',
  'sellerId': '商家ID',
  'channel': '渠道',
  'traceId': 'Trace'
};
var refundOrderTitleObj = {
  'sellerId': '商家ID',
  'userId': '用户ID',
  'orderSource': '订单来源',
  'orderType': '订单类型',
  'payChannel': '交易方式',
  'mainOrderNo': '主订单号',
  'refundOrderNo': '退款单号',
  'refundTradeNo': '退款交易号',
  'isAllRefund': '是否整单退款',
  'totalAmount': '订单总金额',
  'totalPay': '订单总实付',
  'refundAmount': '退款金额',
  'createdAt': '下单时间',
  'payAt': '支付时间',
  'refundAt': '退款时间'
};
var orderGoodsTitleObj = {
  'billNo': '销售流水号',
  'billRemark': '销售备注',
  'billType': '账单类型',
  'sellerOrderType': '销售类型',
  'stationName': '站点名称',
  'goodsNo': '油枪编号 / 商品条形码',
  'goodsName': '油品名称 / 商品名称',
  'goodsOriginal': '国家价（元/升） / 商品原价',
  'goodsPrice': '油机单价（元/升） / 商品零售价',
  'goodsNum': '油机升数（升） / 商品件数',
  'payablesAmount': '油机金额（元） / 商品总价',
  'goodsSettlement': '优惠单价（元/升） / 商品结算价',
  'receivablesAmount': '实收金额（元）',
  'sellerDiscountAmount': '会员优惠金额（元）',
  'couponDiscountAmount': '券优惠金额（元）',
  'pointDiscountAmount': '积分优惠金额（元）',
  'discountCapitalCat2Amount': '优惠出资-新文旅',
  'tradeDiscount': '支付优惠 / 充值赠送',
  'mainOrderNo': '主订单号',
  'orderNo': '子订单号',
  'orderSource': '消费来源',
  'orderType': '消费类型',
  'tradeChannel': '交易方式',
  'payType': '交易类型',
  'CreatedAt': '下单时间',
  'payAt': '支付时间',
  'refundAt': '退款时间',
  'refundAmount': '退款金额',
  'uuid': '用户ID',
  'mobile': '手机号',
  'nickname': '用户名称',
  'svcCard': '卡号',
  'isBrUser': '是否会员',
  'gift': '赠品1',
  'giftNum': '赠品1数量',
  'giftCost': '赠品1成本',
  'gift2': '赠品2',
  'giftNum2': '赠品2数量',
  'giftCost2': '赠品2数量'
};
var shopOrderTitleObj = {
  'CreatedAt': '下单时间',
  'billRemark': '备注',
  'stationName': '站点',
  'goodsNo': '条码',
  'goodsName': '商品',
  'goodsPrice': '零售价',
  'goodsNum': '数量',
  'payablesAmount': '总价',
  'receivablesAmount': '实收',
  'sellerDiscountAmount': '促销优惠',
  'couponDiscountAmount': '券优惠',
  'pointDiscountAmount': '积分优惠',
  'orderType': '消费类型',
  'tradeChannel': '结算方式',
  'payType': '交易类型',
  'isBrUser': '是否会员',
  'mobile': '手机号',
  'nickname': '用户名称',
  'svcCard': '卡号',
  'mainOrderNo': '主订单号',
  'payAt': '支付时间',
  'refundAt': '退款时间',
  'refundAmount': '退款金额',
  'uuid': '用户ID'
};
var shopOrderItemTitleObj = {
  'CreatedAt': '下单时间',
  'billRemark': '备注',
  'stationName': '站点',
  'goodsNo': '条码',
  'goodsName': '商品',
  'goodsPrice': '零售价',
  'goodsNum': '数量',
  'payablesAmount': '总价',
  'receivablesAmount': '实收',
  'sellerDiscountAmount': '促销优惠',
  'couponDiscountAmount': '券优惠',
  'pointDiscountAmount': '积分优惠',
  'tradeChannel': '结算方式',
  'mobile': '手机号',
  'nickname': '用户名称',
  'mainOrderNo': '主订单号',
  'payAt': '支付时间',
  'refundAt': '退款时间',
  'refundAmount': '退款金额'
};
var shopBillTitleObj = {
  'CreatedAt': '下单时间',
  'billRemark': '备注',
  'sellerId': '站点',
  'payablesAmount': '总价',
  'paymentsAmount': '实收',
  'discountAmount': '优惠',
  'tradeChannel': '结算方式',
  'isBrUser': '是否会员',
  'mainOrderNo': '主订单号',
  'payAt': '支付时间',
  'refundAt': '退款时间',
  'uuid': '用户ID'
};
var oilOrderTitleObj = {
  'CreatedAt': '下单时间',
  'billRemark': '备注',
  'stationName': '站点',
  'goodsNo': '枪号',
  'goodsName': '油品',
  'goodsOriginal': '国家价',
  'goodsPrice': '挂牌价',
  'goodsNum': '升数',
  'payablesAmount': '油机金额',
  'goodsSettlement': '优惠价',
  'receivablesAmount': '实收',
  'sellerDiscountAmount': '油品优惠',
  'couponDiscountAmount': '券优惠',
  'pointDiscountAmount': '积分优惠',
  'tradeDiscount': '支付优惠',
  'orderType': '消费类型',
  'tradeChannel': '结算方式',
  'payType': '交易类型',
  'isBrUser': '是否会员',
  'mobile': '手机号',
  'nickname': '用户名称',
  'svcCard': '卡号',
  'mainOrderNo': '主订单号',
  'payAt': '支付时间',
  'refundAt': '退款时间',
  'refundAmount': '退款金额',
  'uuid': '用户ID',
  'gift': '赠品1',
  'giftNum': '赠品1数量',
  'giftCost': '赠品1成本',
  'gift2': '赠品2',
  'giftNum2': '赠品2数量',
  'giftCost2': '赠品2数量'
};
var chargeOrderTitleObj = {
  'CreatedAt': '下单时间',
  'billRemark': '备注',
  'stationName': '站点',
  'payablesAmount': '充值金额',
  'receivablesAmount': '实收',
  'tradeDiscount': '赠送金额',
  'orderType': '消费类型',
  'tradeChannel': '结算方式',
  'isBrUser': '是否会员',
  'mobile': '手机号',
  'nickname': '用户名称',
  'svcCard': '卡号',
  'mainOrderNo': '主订单号',
  'payAt': '支付时间',
  'refundAt': '退回时间',
  'refundAmount': '退回金额',
  'uuid': '用户ID'
};
var othersOrderTitleObj = {
  'CreatedAt': '下单时间',
  'billRemark': '备注',
  'stationName': '站点',
  'payablesAmount': '金额',
  'receivablesAmount': '实收',
  'orderType': '消费类型',
  'tradeChannel': '结算方式',
  'isBrUser': '是否会员',
  'mobile': '手机号',
  'svcCard': '卡号',
  'mainOrderNo': '主订单号',
  'payAt': '支付时间',
  'refundAt': '退回时间',
  'refundAmount': '退回金额',
  'uuid': '用户ID'
};
var sanSaleTitleObj = {
  'saleID': '销售流水号',
  'energyStationID': '油站名称',
  'fuelNozzelNo': '油枪编号',
  'simFuelName': '油品名称',
  'fuelEngineUP': '油机单价(元/升)',
  'fuelEngineNum': '油机升数(升)',
  'fuelEnginePrice': '油机金额(元)',
  'settlePrice': '优惠单价(元/升)',
  'amountCollecte': '实收金额(元)',
  'couponPrice': '券优惠金额(元)',
  'discountAmount': '系统优惠金额(元)',
  'settlementTypeTitle': '消费类型',
  'fuelNoEndDate': '加油时间',
  'modifiedDate': '结算时间',
  'isBrUser': '是否会员',
  'issuedStation': '发卡油站',
  'customerID': '会员ID',
  'svcMobile': '电话号码',
  'cardID': '储值卡号'
};
var sanSvcRechargeTitleObj = {
  'baseCard': '储值卡号',
  'amount': '充值金额',
  'paymentType': '支付方式',
  'rechargeStation': '油站名称',
  'rechargeDate': '充值时间',
  'discount92': '92#优惠',
  'discount95': '95#优惠',
  'discount98': '98#优惠',
  'discount0': '0#优惠'
};
var adminSvcOptTitleObj = {
  'svcOptNumber': '卡号',
  'stationName': '油站',
  'optType': '操作类型',
  'balance': '操作金额',
  'beforeBalance': '操作前金额',
  'afterBalance': '操作后金额',
  'uuid': '用户id',
  'mobile': '手机号',
  'remark': '备注'
};
var userTitleObj = {
  'mobile': '用户手机号',
  'userId': '用户ID',
  'svcNo': '用户卡号',
  'totalSvcCharge': '累计充值',
  'totalSvcConsume': '累计消费'
};
var billTypeObj = {
  1: '收入',
  2: '退款'
};
var sellerOrderTypeObj = {
  1: '油品',
  2: '便利店',
  3: '地磅称重',
  4: '充值',
  5: '兑换'
};
var svcOptTypeObj = {
  1: '回款',
  2: '授钱',
  3: '消费退款',
  4: '消费',
  5: '充值退款',
  6: '充值',
  7: '创建卡',
  8: '删除',
  9: '批量删除',
  10: '挂失',
  11: '解挂',
  12: '批量启用',
  13: '批量禁用',
  14: '更换密码',
  15: '换卡',
  16: '退卡'
};
var goodsCategoryObj = {
  1627264658: '洗车服务',
  1000000000: '充值',
  1100000001: '汽油',
  1100000002: '柴油',
  1635919042: '休闲食品',
  1635919054: '家庭护理',
  1635919065: '汽车用品',
  1635919085: '粮油调品',
  1635919094: '糖果类',
  1635919108: '酒茶饮品',
  1635919117: '饮料类',
  1635919126: '饼干糕点',
  1635919134: '香烟类',
  1636009344: '赠品',
  1640434105: '大礼包',
  1662522745: '农副产品',
  1670903466: '虚拟商品'
};
var tagsObj = {
  't_1': '汽车',
  't_2': '货车',
  't_4': '摩托车',
  't_5': '特殊作业车'
};
var tagsClassObj = {
  't_1': 'success',
  't_2': 'warning',
  't_4': 'info',
  't_5': 'danger'
};
var stationList = {
  getPayChannels: function getPayChannels() {
    return payChannelObj;
  },
  getDailyPayChannels: function getDailyPayChannels() {
    var newObj = {};
    Object.keys(payChannelObj).forEach(function (key) {
      if (parseInt(key) > 2000 && parseInt(key) < 3000 && key !== '2006' || key === '1005' || key === '1015' || key === '1025' || key === '1045' || key === '1006' || key === '1008' || key === '1009') {
        newObj[key] = payChannelObj[key];
      }
    });
    return newObj;
  },
  getOrderGoodsTitleMaps: function getOrderGoodsTitleMaps() {
    var sellerOrderType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

    if (sellerOrderType === 1) {
      return oilOrderTitleObj;
    }

    if (sellerOrderType === 2) {
      return shopOrderTitleObj;
    }

    if (sellerOrderType === 3) {
      return othersOrderTitleObj;
    }

    if (sellerOrderType === 4) {
      return chargeOrderTitleObj;
    }

    if (sellerOrderType === 200) {
      return shopBillTitleObj;
    }

    if (sellerOrderType === 201) {
      return shopOrderItemTitleObj;
    }

    return orderGoodsTitleObj;
  },
  getSanSaleTitleMaps: function getSanSaleTitleMaps() {
    return sanSaleTitleObj;
  },
  getSanSvcRechargeTitleMaps: function getSanSvcRechargeTitleMaps() {
    return sanSvcRechargeTitleObj;
  },
  getAdminSvcOptTitleMaps: function getAdminSvcOptTitleMaps() {
    return adminSvcOptTitleObj;
  },
  getUserTitleMaps: function getUserTitleMaps() {
    return userTitleObj;
  },
  getOSOTPCTitle: function getOSOTPCTitle(key) {
    var obj = Object.assign({}, orderSourceObj, orderTypeObj, chargeOrderTypeObj, payChannelObj);
    return obj[key] ? obj[key] : key;
  },
  getPtTitle: function getPtTitle(key) {
    var obj = Object.assign({}, payTypeObj);
    return obj[key] ? obj[key] : '';
  },
  getBillTypeTitle: function getBillTypeTitle(key) {
    var obj = Object.assign({}, billTypeObj);
    return obj[key] ? obj[key] : key;
  },
  getSellerOrderTypeTitle: function getSellerOrderTypeTitle(key) {
    var obj = Object.assign({}, sellerOrderTypeObj);
    return obj[key] ? obj[key] : key;
  },
  getSvcOptTypeTitle: function getSvcOptTypeTitle(key) {
    var obj = Object.assign({}, svcOptTypeObj);
    return obj[key] ? obj[key] : key;
  },
  getGoodsCategoryTitle: function getGoodsCategoryTitle(key) {
    var goodsSpu = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var obj = Object.assign({}, goodsCategoryObj);

    if (goodsSpu !== '' && goodsSpu.indexOf('gift') === 0) {
      key = 1636009344;
    }

    return obj[key] ? obj[key] : '';
  },
  getTagTitle: function getTagTitle(key) {
    var obj = Object.assign({}, tagsObj);
    return obj[key] ? obj[key] : key;
  },
  getTagTitleClass: function getTagTitleClass(key) {
    var obj = Object.assign({}, tagsClassObj);
    return obj[key] ? obj[key] : 'primary';
  }
};
export default stationList;